

module.exports = angular.module;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/module.js
// module id = ./components/squid/dist/module.js
// module chunks = 1